import * as React from 'react';
import { noop } from '@Utils/facade/lodash';
import { automationLabels } from '@Utils/facade/edgeTs';

interface DangerousInnerHTMLProps {
  html: string;
  tagName?: string;
  className?: string;
  style?: any;
  onClick?: (event: React.MouseEvent) => void;
}

const DangerousInnerHTML: ReactFCWithChildren<DangerousInnerHTMLProps> = ({
  html,
  tagName = 'div',
  className = '',
  style,
  onClick = noop,
  ...props
}) => {
  return React.createElement(tagName || 'div', {
    dangerouslySetInnerHTML: { __html: html },
    className,
    style: style || {},
    onClick,
    ...automationLabels.extractProps(props),
  });
};

export default DangerousInnerHTML;
